export const environment = {
  production: true,
  APIEndpoint : '/api/v1',
  SiebelAPIEndpoint : ''
  //APIEndpoint : "http://localhost:3001/api/v1",
  //SiebelAPIEndpoint:"http://localhost:3001"
};
